import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";

export interface FunnelInfo {
  isFunnel: boolean;
  expiryDate: string;
  redirectUrl?: string;
}

export const fetchFunnelInfo = (apiInfo: ModuleApiInfo): Promise<FunnelInfo | null> => {
  return api
    .get<FunnelInfo>(apiInfo, "/api/site/v1/modules/CountdownTimers/GetFunnel", {
      pageId: apiInfo.baseParams.pageVariantId
    })
    .then((res) => (res.error ? null : res.response!.data));
};
